import { Tab, Tabs } from '@mui/material';
import { concat, filter, map } from 'es-toolkit/compat';
import React from 'react';

import { OperatingSystem } from 'utils/osDetection';

const osToTabMap: Record<OperatingSystem, React.ReactElement> = {
  mac: <Tab key="mac" value="mac" label="macOS" />,
  windows: <Tab key="windows" value="windows" label="Windows" />,
  linux: <Tab key="linux" value="linux" label="Linux" />,
};

const tabs = Object.keys(osToTabMap) as OperatingSystem[];

export const OsTabs = ({
  ariaLabel,
  selectedOs,
  setSelectedOs,
  defaultOperatingSystem = 'mac',
}: {
  ariaLabel: string;
  selectedOs: OperatingSystem;
  setSelectedOs: (operatingSystem: OperatingSystem) => void;
  defaultOperatingSystem?: OperatingSystem;
}) => {
  const tabsOrder: OperatingSystem[] = defaultOperatingSystem
    ? concat(
        [defaultOperatingSystem],
        filter(tabs, (os) => os !== defaultOperatingSystem)
      )
    : tabs;

  return (
    <Tabs
      value={selectedOs}
      onChange={(_event, value: OperatingSystem) => setSelectedOs(value)}
      aria-label={ariaLabel}
      variant="scrollable"
      allowScrollButtonsMobile
    >
      {map(tabsOrder, (os) => osToTabMap[os])}
    </Tabs>
  );
};
